import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Loading from "../../../components/__common/Loading/Loading";
import { ROUTES } from "../../../configs/routes";

import { REQUEST_NUMBER } from "../../../constants/storage";
import { URLS } from "../../../constants/urls";
import { useAuth } from "../../../hooks/auth-hooks";
import { useQuery } from "../../../hooks/query-hooks";
import { Cookie } from "../../../services/storage";
import { ApplicationState } from "../../../store";
import { UserState } from "../../../store/reducers/user-reducer";

export const Login: React.FC = () => {
  const query: any = useQuery();
  const { login } = useAuth();
  const userState = useSelector<ApplicationState, UserState>(
    (state) => state.user
  );

  useEffect(() => {
    const body = document.body;
    body.classList.add("modal-open");

    return () => {
      body.classList.remove("modal-open");
    };
  });

  useEffect(
    () => {
      if (!userState.isGeoIPLoading) {
        const requestNumber = Cookie.get(REQUEST_NUMBER);

        if (
          [ROUTES.MYDATA, ROUTES.MYDATA_HISTORY].includes(query.get("redirect"))
        ) {
          Cookie.remove(REQUEST_NUMBER);
        }

        if (!requestNumber) {
          login(query.get("redirect"));
        } else {
          let redirectUri = query
            .get("redirect")
            .replace(`/${requestNumber}`, "");
          if (redirectUri === `${URLS.OLD_MYDATA}${URLS.OLD_REQUEST_DETAILS}`) {
            redirectUri = ROUTES.MYDATA_HISTORY;
          }

          login(redirectUri);
        }
      }
    },
    // eslint-disable-next-line
    [userState.isGeoIPLoading]
  );

  return <Loading />;
};
